export const handleConfigurableProduct = (chosenConfigurable, product) => {
  return {
    ...product,
    prices_with_tax:
      chosenConfigurable?.prices_with_tax || product?.prices_with_tax,
    short_description:
      chosenConfigurable?.short_description || product?.short_description,
    _media_:
      chosenConfigurable?._media_?.image?.length > 0
        ? chosenConfigurable?._media_
        : product?._media_,
    stock: {
      qty: chosenConfigurable?.quantity || 0,
      is_in_stock: chosenConfigurable?.quantity > 0,
    },
    pg_stock: {
      qty: chosenConfigurable?.quantity || 0,
      is_in_stock: chosenConfigurable?.quantity > 0,
    },
    sku: Array.isArray(product?.sku) ? product?.sku[0] : product?.sku,
    viewedSku: chosenConfigurable?.sku || product?.sku, // used in product details section

    // new properties added to simplify the process
    current_option: chosenConfigurable?.option_details || null,
    configurable_options: getConfigurableOptions(product?._configurables),
  };
};

const getConfigurableOptions = (configurables) => {
  const optionMap = {};

  configurables.forEach((item) => {
    // Loop through each option detail (e.g., color, size, etc.)
    for (const key in item.option_details) {
      if (!optionMap[key]) {
        optionMap[key] = [];
      }

      const option = item.option_details[key];

      // Add the option only if it doesn't already exist in our map
      if (
        !optionMap[key].some(
          (existing) => existing.option_value === option.option_value
        )
      ) {
        optionMap[key].push({
          ...option,
          image:
            item?._media_?.image?.length > 0
              ? item?._media_?.image?.[0]?.image
              : null,
        });
      }
    }
  });

  return Object.keys(optionMap).map((key) => ({
    label: key,
    options: optionMap[key],
  }));
};
